import { useStationeryProductPricingContext } from '@apps/card/components/ProductUIConfig/utils/useStationeryProductPricingContext';
import type { PriceSummaryProps } from './GenericPriceSummary';
import { GenericPriceSummary } from './GenericPriceSummary';
import React from 'react';
import { useProductPriceSummaryController } from './ProductPriceSummary.controller';
import LegacyPriceSummary from './LegacyPriceSummary';

const PriceSummary: React.FC<PriceSummaryProps> = props => {
  const { attributes, priceUpTo, cardConfig, salesTax, promotion } = props;
  const { activeProduct, priceCalculator, products } = useStationeryProductPricingContext();
  const shouldShowShipping = priceUpTo === 'total';
  const summary = useProductPriceSummaryController(priceCalculator, cardConfig, activeProduct, attributes, shouldShowShipping, salesTax, promotion ?? undefined);

  if (!products.length) return <LegacyPriceSummary {...props} />;

  return (
    <GenericPriceSummary
      {...props}
      summary={summary}
    />
  );
};

export default PriceSummary;
